import React from 'react';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';

const AppHeader = () => (
  <div className="App-header">
    <AppBar position="static" elevation={0}>
      <div className="Content-wrapper ">
        <div className="content">
          <Toolbar disableGutters>
            <h1 className="App-title">Der Währungsrechner</h1>
          </Toolbar>
        </div>
      </div>
    </AppBar>
  </div>
);

export default AppHeader;



// WEBPACK FOOTER //
// ./src/components/layout/AppHeader.js